export enum TypeTokenEnum {
    SET_NEW_PASSWORD = 'SET_NEW_PASSWORD'
}

